import { Client } from 'typesense';

// Indeksnavn – speiler @casetrace/search-konstantene uten å importere
// server-avhengig pakke i web-bygget.
export const EVENTS_COLLECTION = 'events_index';
export const PEOPLE_COLLECTION = 'people_index';
export const DOCUMENTS_COLLECTION = 'documents_index';
export const ORGANIZATIONS_COLLECTION = 'organizations_index';

function isLocalHost(host: string): boolean {
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
}

/**
 * Opprett en Typesense søkeklient fra Vite-miljøvariabler.
 * Returnerer null hvis VITE_TYPESENSE_HOST eller VITE_TYPESENSE_SEARCH_API_KEY
 * mangler – appen fortsetter gracefully uten søk.
 *
 * MERK: Produksjon krever server-utstedte scoped Typesense search-keys
 * per bruker (begrenset til brukerens caseIds). Se bruk i use-search.ts.
 * Det er en oppfølging utenfor PR11.
 */
function createClient(): Client | null {
  const host = import.meta.env.VITE_TYPESENSE_HOST;
  const apiKey = import.meta.env.VITE_TYPESENSE_SEARCH_API_KEY;

  if (!host || !apiKey) return null;
  if (import.meta.env.PROD && isLocalHost(host)) {
    console.warn('Typesense er deaktivert: produksjonsbuild peker mot localhost.');
    return null;
  }

  const port = Number(import.meta.env.VITE_TYPESENSE_PORT ?? 443);
  const protocol = import.meta.env.VITE_TYPESENSE_PROTOCOL ?? 'https';

  return new Client({
    nodes: [{ host, port, protocol }],
    apiKey,
    connectionTimeoutSeconds: 5,
  });
}

// Singleton – instansieres én gang ved modul-load
export const typesenseClient = createClient();
